import * as ActionTypes from '../actions/ActionTypes';
import { LINK_TYPES } from 'MeetingsBase/constants/enums';
const initialState = null;
export default function emailFormState(state = initialState, action) {
  switch (action.type) {
    case ActionTypes.SET_EMAIL_FORM:
      return action.payload;
    case ActionTypes.RESET_EMAIL_FORM:
      return initialState;
    case ActionTypes.PUBLIC_AVAILABILITY_INFO_FETCH_SUCCEEDED:
      {
        const {
          bookInfo: {
            customParams,
            formPrefills,
            linkType
          }
        } = action.payload;
        const isOwnerPrioritized = customParams.get('ownerPrioritized');
        const shouldAutoSubmit = customParams.get('shouldAutoSubmit');
        const isRoundRobin = linkType === LINK_TYPES.get('roundRobin');

        // We don't want to influence round robin availability so setting this explicitly to null because an email (defined by the `state` variable) can still be set by query parameter even if the owner is not prioritized and don't want to implicitly set the value if auto-submit is disabled.
        if (!isOwnerPrioritized || !isRoundRobin || !shouldAutoSubmit) {
          return null;
        }
        const prefillEmail = formPrefills.get('email');
        if (prefillEmail && state) {
          return state !== prefillEmail ? state : prefillEmail;
        }
        if (prefillEmail) {
          return prefillEmail;
        }
        return state;
      }
    default:
      return state;
  }
}